import React, { useState, useEffect } from "react";
import { getAllData, deleteIdData } from "../../../lib/resourcecenterview";
import { useNavigate, Link } from "react-router-dom";

function GlobalResource({ slug, isStudent }) {
    const [resources, setResources] = useState([]);
    const [showMessage, setShowMessage] = useState(false);

    const [filteredResources, setFilteredResources] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");

    const navigate = useNavigate();

    const GetData = async () => {
        const data = await getAllData();
        console.log("data", data);

        setResources(data);
        setFilteredResources(data);
        setShowMessage(false);
    };

    useEffect(() => {
        GetData();
    }, []);

    // Handle search query and filter resources
    useEffect(() => {
        const filterData = () => {
            const filtered = resources.filter(
                (resource) =>
                    resource.howuse
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                    resource.pname
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                    resource.name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                    resource.surname
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
            );
            setFilteredResources(filtered);
        };

        filterData();
    }, [searchQuery, resources]);

    // Handle sorting by topic with ascending/descending toggle
    const handleSortByTopic = () => {
        const sortedResources = [...filteredResources].sort((a, b) => {
            const topicA = a.pname.toLowerCase();
            const topicB = b.pname.toLowerCase();
            return sortOrder === "asc"
                ? topicA.localeCompare(topicB)
                : topicB.localeCompare(topicA);
        });
        setFilteredResources(sortedResources);

        // Toggle the sort order
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleDelete = async (id) => {
        const choice = window.confirm("Are you sure you want to delete?");
        if (choice) {
            await deleteIdData(id);
            GetData();
        }
    };

    return (
        <div className="comman-space p-2 card wish-card">
            {showMessage && (
                <div
                    className="alert alert-success alert-dismissible fade show"
                    role="alert"
                >
                    <strong>Updated!</strong> Your information.
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                    ></button>
                </div>
            )}
            <h1 className="text-center mb-2">Resource Center</h1>
            <div className="d-flex justify-content-end mb-3">
                {/* Search box */}
                <input
                    type="text"
                    className="form-control w-25"
                    placeholder="Search resources..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />

                {isStudent ? (
                    ""
                ) : (
                    <button
                        className="btn btn-dark"
                        onClick={() =>
                            navigate(
                                `/instructor/instructor-resource-edit/${slug}/Add/0`
                            )
                        }
                    >
                        Add Resource
                    </button>
                )}
            </div>

            {/* Sort by topic */}
            <div className="mb-3">
                <button
                    className="btn btn-secondary"
                    onClick={handleSortByTopic}
                >
                    Sort by Topic (
                    {sortOrder === "asc" ? "Ascending" : "Descending"})
                </button>
            </div>

            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead style={{ backgroundColor: "#bfbfbf" }}>
                        <tr>
                            <th
                                style={{
                                    backgroundColor: "#bfbfbf",
                                    color: "white",
                                }}
                            >
                                Topic
                            </th>
                            <th
                                style={{
                                    backgroundColor: "#bfbfbf",
                                    color: "white",
                                }}
                            >
                                How to use it
                            </th>
                            <th
                                style={{
                                    backgroundColor: "#bfbfbf",
                                    color: "white",
                                }}
                            >
                                Grade
                            </th>
                            <th
                                style={{
                                    backgroundColor: "#bfbfbf",
                                    color: "white",
                                }}
                            >
                                Date
                            </th>
                            <th
                                style={{
                                    backgroundColor: "#bfbfbf",
                                    color: "white",
                                }}
                            >
                                Instructor
                            </th>
                            <th
                                style={{
                                    backgroundColor: "#bfbfbf",
                                    color: "white",
                                    display: "none",
                                }}
                            >
                                Link-1
                            </th>
                            {isStudent ? (
                                ""
                            ) : (
                                <th
                                    style={{
                                        backgroundColor: "#bfbfbf",
                                        color: "white",
                                    }}
                                >
                                    Actions
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredResources.map((resource) => (
                            <tr key={resource.id}>
                                <td>{resource.pname}</td>
                                <td>
                                    <a
                                        href={resource.link1}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {resource.howuse}
                                    </a>
                                </td>
                                <td>{resource.grade}</td>
                                <td>{resource.rdate}</td>
                                <td>
                                    {resource.name + " " + resource.surname}
                                </td>

                                {isStudent ? (
                                    ""
                                ) : (
                                    <td className="profile-share d-flex align-items-center justify-content-end">
                                        <Link
                                            to={`/instructor/instructor-resource-edit/${slug}/Update/${resource.id}`}
                                            className="btn btn-success btn-sm"
                                        >
                                            Update
                                        </Link>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() =>
                                                handleDelete(resource.id)
                                            }
                                        >
                                            Delete
                                        </button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default GlobalResource;
